<template>
    <v-container fluid>
        <v-layout align-center justify-center>
            <div class="text-center">
                <v-img style="margin: auto" width="150" class="mb-3" src="../assets/success.png"/>
                <h3>Order telah dibuat</h3>
                <p>Nomor Order {{order.invoice}}</p>
                <p>Jumlah TokenSMS: {{formatAngka(order.totaltokensms)}}</p>
                <p>Jumlah Bayar: {{formatAngka(order.price)}}</p>
                <p>Silahkan Transfer Ke Rekening</p>
                <h2>BCA: 0404664545 PT Aviana Teknologi Nusantara</h2>
                <p>untuk konfirmasi transfer silahkan ke telegram</p>
                <p><a href="https://t.me/Avianaadminirs1" target="_blank">Admin IRS @Avianaadminirs1</a></p>
<!--                <p>Silahkan Transfer Ke Nomor Virtual Account</p>-->
<!--                <h2>BCA:{{order.nova}}</h2>-->
<!--                <h2>BRI: {{order.briva}}</h2>-->
<!--                <v-btn class="mt-3" @click="getData" dark color="green">Check Status</v-btn>-->
                <v-btn class="mt-3 ml-4" @click="kembali" dark color="pink">Kembali</v-btn>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    import  { mapActions,mapState } from 'vuex'
    export default {
        name: "SMSTokenOrderSUkses",
        data: ()=>({

        }),
        computed: {
            ...mapState('TokenSMS', ['order', 'dialog', 'loading']),
        },
        mounted(){
            this.getData()
        },
        methods: {
            ...mapActions('TokenSMS',['getOrdersByid']),
            kembali(){
                this.$router.push('/tokensms');
            },
            getData(){
                this.getOrdersByid(this.$route.params.orderid);
            },
            formatAngka(angka) {
                var rev = parseInt(angka, 10).toString().split('').reverse().join('');
                var rev2 = '';
                for (var i = 0; i < rev.length; i++) {
                    rev2 += rev[i];
                    if ((i + 1) % 3 === 0 && i !== (rev.length - 1)) {
                        rev2 += '.';
                    }
                }
                return rev2.split('').reverse().join('').toString();
            }
        }
    }
</script>

<style scoped>

</style>
